import { z } from 'zod';

import { ProseMirrorJSONSchema } from './ProseMirrorJSONSchema';
import { BaseQuestionWidgetSchema, Feedbacks, QuestionScoreMode } from './QuestionBaseSchema';
import { AnswerStyleType, ObjectFit } from './SelectionQuestionWidgetStaticSchema';
import { ChartType } from '../../../types/ChartType';
import { WidgetType } from '../../utils/widgetsUtils';

const AnswerSchema = z.object({
  id: z.string(),
  text: z
    .object({
      /**
       * ProseMirror JSON
       */
      fragment: ProseMirrorJSONSchema
    })
    .optional(),
  image: z
    .object({
      src: z.string(),
      alt: z.string(),
      mobileSrc: z.string(),
      objectFit: z.nativeEnum(ObjectFit),
      mobileObjectFit: z.nativeEnum(ObjectFit),
      isDecorative: z.boolean().optional()
    })
    .optional(),
  audio: z
    .object({
      src: z.string(),
      title: z.string()
    })
    .optional()
});

export const InteractiveQuizWidgetStaticSchema = BaseQuestionWidgetSchema(WidgetType.InteractiveQuiz).extend({
  amountOfColumns: z.number(),
  answerElements: z.array(z.string()),
  answers: z.array(AnswerSchema),
  answersStyle: z.nativeEnum(AnswerStyleType),
  answersVisualization: z.nativeEnum(ChartType),
  isSingleAnswerQuestion: z.boolean(),
  withRandomAnswers: z.boolean().optional(),
  // Override base question fields as optional - old InteractiveQuiz instances
  // predate createQuestionDataHandler adoption and lack these fields (no migration)
  feedback: z.nativeEnum(Feedbacks).optional(),
  hintFragment: ProseMirrorJSONSchema.optional(),
  questionScoreMode: z.nativeEnum(QuestionScoreMode).optional(),
  showAnswerButton: z.boolean().optional(),
  showFeedback: z.boolean().optional(),
  showHintButton: z.boolean().optional(),
  showIndicatorButton: z.boolean().optional()
});

export type InteractiveQuizWidgetStaticSchemaType = z.infer<typeof InteractiveQuizWidgetStaticSchema>;
